import { createSelector } from 'reselect';
import _ from 'lodash';
import { BOOTH_TYPE } from '../common/Constants';

const AdminCompanyManagementSelector = {
    createDetailCompanySelector: () => createSelector([
        (state) => state.adminCompanyManagement.detailCompany.data.company,
        (state) => state.adminCompanyManagement.detailCompany.data.user,
        (state) => state.adminCompanyManagement.detailCompany.data.seminars,
        (state) => state.adminCompanyManagement.detailCompany.data.live_stream,
    ], (company, user, seminars, liveStream) => {
        if (!_.isEmpty(company) && !_.isEmpty(user) && seminars && (!_.isEmpty(liveStream) || _.isEmpty(liveStream))) {
            return {
                idCompany: company.id,
                idUser: company.user,
                fullName: company.full_name,
                fullNameEN: company?.full_name_en,
                shortName: company.short_name,
                shortNameEN: company?.short_name_en,
                companyType: company.company_type,
                companyCategory: company.companyCategory,
                image: company.image,
                department: user.department,
                url: company.url,
                position: user.position,
                location: user.location,
                address: user.address,
                addressEN: user.address_en,
                email: user.email,
                zipCode: user.zip_code,
                phoneNumber: user.phone_number,
                faxNumber: user.fax_number,
                firstName: user.first_name,
                lastName: user.last_name,
                description: company.description,
                descriptionEN: company.description_en,
                organizerBooth: user.organizer_booth,
                register_ads_max: company.register_ads_max,
                seminars,
                booth: user.organizer_booth,
                employee_number: user.employee_number,
                occupationName: user.occupation_name,
                zone: user.zone,
                live_stream: liveStream || [],
                isOrderWaiting: company.is_in_order_waiting,
                has_payment: company.payment_method,
            };
        }
        return {};
    }),
    createSeminarManagementResultsSelector: () => createSelector([
        (state) => state.adminCompanyManagement.listSeminar.data,
    ], (results) => {
        if (!_.isEmpty(results)) {
            return results;
        }
        return [];
    }),
    createSettingDisplayInfoProductSelector: () => createSelector([
        (state) => state.eventManagement.infoEvent.data,
        (state) => state.adminCompanyManagement.detailCompany.data,
    ], (info, detailCompany) => {
        if (!_.isEmpty(detailCompany) && detailCompany.user) {
            const { setting_booth } = info;
            if (setting_booth && detailCompany.user.organizer_booth === BOOTH_TYPE.BIG) {
                return setting_booth.big_zone.settings_display_info_product;
            }

            if (setting_booth && detailCompany.user.organizer_booth === BOOTH_TYPE.STANDARD) {
                return setting_booth.standard_zone.settings_display_info_product;
            }

            if (setting_booth && detailCompany.user.organizer_booth === BOOTH_TYPE.SMALL) {
                return setting_booth.small_zone.settings_display_info_product;
            }

            if (setting_booth && detailCompany.user.organizer_booth === BOOTH_TYPE.GRAND) {
                return setting_booth.grand_zone.settings_display_info_product;
            }
        }
        return {};
    }),
};

export default AdminCompanyManagementSelector;
